import React, { useState, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ResponsiveContext } from '../../App';
import { Simulation } from '../../types/main';
import { creeClassNamesZoneSaisie } from '../../utils/utils';
import { SaisieContext } from '../formConteneur';
import { MySelect } from '../champsSaisieAffichage/mySelect';
import { MyListeBoutons } from '../champsSaisieAffichage/myListeBoutons';
import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
// import { VoirDetail } from '../boutons/generaux/voirDetail';

export const SaisieFiliere: React.FC = () => {
  // const { etapeSaisie, etapesSaisie } = useContext(EtapesSaisieContext);
  const { values, setFieldValue } = useFormikContext();
  const { modeAffichage, setBoutonSuivant } = useContext(SaisieContext);
  const simulation = values as Simulation;
  const { dimensions } = useContext(ResponsiveContext);
  const classNamesZoneSaisie = creeClassNamesZoneSaisie(dimensions.largeur, 4);

  useEffect(() => {
    setBoutonSuivant('non');
  }, [])

  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
      // style={styleZoneSaisie}
    >
      <div className="col1">
        <div className="col">
          <h1 className="titre">Filière</h1>
          <div className="group" style={{ display: "flex" }}>
            <MyListeBoutons
              label="Filière"
              // labelAvecRC={<><u>F</u>ilière</>}
              // toucheRC={['f', 'F']}
              name="filiere"
              required
              boutons={['ES', 'S', 'L']}
              toucheRC={['s', 'S', 'e', 'E', 'l', 'L']}
              matchTouchesElement={[0, 0, 1, 1, 2, 2]}
              boutonsDesactives={[]}
              classes={['boutonSize1']}
            />
          </div>

        </div>
      </div>
    </div>
  );
};
